<template>
    <div>
        <div v-if="!loggedInInternal" style="white-space:nowrap">
            <v-btn
                v-if="showSignUp"
                text
                @click="$emit('signup')"
                :small="$vuetify.breakpoint.xsOnly"
                :class="{'pr-0': $vuetify.breakpoint.xsOnly}"
            >
              <span class="mr-2">Sign Up</span>
            </v-btn>
            <v-btn
                text
                @click="$emit('login')"
                :small="$vuetify.breakpoint.xsOnly"
                :class="{'pr-0': $vuetify.breakpoint.xsOnly}"
            >
              <span class="mr-2">Login</span>
            </v-btn>
        </div>
        <div v-else style="white-space: nowrap;">
            <v-btn
                text
                @click="$emit('profile')"
                :small="$vuetify.breakpoint.xsOnly"
                :class="{'pr-0': $vuetify.breakpoint.xsOnly}"
            >
              <span class="mr-2">Profile</span>
            </v-btn>
            <v-btn
                text
                @click="$emit('logout')"
                :class="{'pr-0': $vuetify.breakpoint.xsOnly}"
                :small="$vuetify.breakpoint.xsOnly"
            >
                <span class="mr-2">Logout</span>
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginButton',
    beforeUpdate() {
      this.$emit('check')
    },
    created() {
      this.$emit('check')
    },
  props: {
    showSignUp: {
      type: Boolean,
      default: true,
    },
    loggedIn: {
      type: Function,
      default: function() {
        return this.$store.state.loggedIn
      }
    }
  },
    computed: {
        loggedInInternal() {
            return this.loggedIn()
        },
    },
    methods: {
    },
}
</script>
